<template>
    <div style="display: flex; height: 100%; ">
        <v-row style="margin: 0px; height: 80%; align-self: center;">
            <v-col class="tableau">
                <v-data-table  
                        class="moduleTable"
                        :items="modules" 
                        :headers="headerModules" 
                        :items-per-page="-1"
                        fixed-header 
                        hide-default-footer>
                    <template v-slot:top>
                        <v-toolbar flat style="background-color:#F2F4F4">
                            <v-toolbar-title>{{ $t('_modules_') }}</v-toolbar-title>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon
                        small
                        @click.stop="deleteItem(item)"
                        >
                        mdi-minus-box
                        </v-icon>
                    </template>
                </v-data-table>

            </v-col>
            <v-col class="formulaire">
                <v-btn @click="this.openModal" class="ajoutModeleBouton">
                            <div >{{$t("_je_ne_trouve_pas_mon_module_")}}</div>
                        </v-btn>
                        <div class="questions">
                        <div class="champs">
                            <div>
                                {{$t("_reference_du_modele_")}} (*)
                            </div>
                            <div class="input inputField">
                                <select class="createSelect" v-model="reponse.ref.value">
                                    <option disabled value=""> </option>
                                    <option v-for="(opt,index) in pvListe" :value="opt.data.key" :key="index"> {{ opt.data.key }}</option>
                                </select>
                            </div>
                        </div>
            
                        
                        <v-btn :disabled="!rempli" style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;" @click="addData()">
                            {{$t("_ajouter_")}}
                        </v-btn>
                        
    </div>
            </v-col>
        </v-row>
        <PopUpAjouterModele v-if="this.modalAjout" :type="'module'" @saveModel="save" @close="modalAjout=false">
            <template v-slot:title>
                {{$t("_ajouter_un_nouveau_module_a_la_liste_")}}
            </template>
        </PopUpAjouterModele>
    </div>
</template>

<script>
import api from "@/api/api";
import PopUpAjouterModele from "./PopUpAjouterModele.vue";
import backend from "@/api/backend";

export default {
    props: {
        initModules : {
            required: false,
        },
        install_id: {
            required: true
        },
        initCalepinage: {  //est modifier si un modele y figurant est supprimé
            required: false
        }
    },

    components: {
        PopUpAjouterModele,
    },

    data() {
        return {
            modules: [],
            pvListe: [],
            calepinage: [],
            headerModules: [
                { key: 'ref', text: this.$t('_reference_du_modele_'), value: 'ref' },
                { key: 'puissanceNominale', text: this.$t('_puissance_nominale_'), value: 'puissanceNominale' },
                { key: 'actions', text: '', value: 'actions', sortable: false },
            ],
            rempli: false,
            reponse: {
                "id": {
                    "value": "",
                    "required": false,
                },
                "ref":  {
                    "value": "",
                    "required": true,
                },
                "puissanceNominale":  {
                    "value": "",
                    "required": false,
                },
            },
            reponseVide: {
                "id": {
                    "value": "",
                    "required": false,
                },
                "ref":  {
                    "value": "",
                    "required": true,
                },
                "puissanceNominale":  {
                    "value": "",
                    "required": false,
                },
            },
            modalAjout: false,
        }
    },

    // pre rempli le formulaire et calepinage avec les données deja enregistées, recupere la liste de modele dans le back d'heliocity et la liste des modele ajouté par l'utilisateur
    //pour cet audit dans le notre
    async mounted(){
        if (this.initModules !== undefined && this.initModules !== null) 
            this.modules = this.initModules
        if (this.initCalepinage !== undefined && this.initCalepinage !== null)
            this.calepinage = this.initCalepinage
        this.pvListe= await api.get_pv_panel_model()

        try{
            const reponse = (await backend.get_models_modules(this.install_id)).data
            reponse.forEach(element => {
                this.pvListe.push(element)
            });
        }
        catch{
            console.log("Pas de module ajouté")
        }

        
    },

    methods: {

        addData() {
            if (this.rempli){
                this.reponse.id.value = this.modules.length + 1
                const parts = this.reponse.ref.value.split("-")
                this.reponse.puissanceNominale.value = parts[parts.length - 1]
                var justeValeurs = {}
                for (var champ in this.reponse) {
                    justeValeurs[champ] = this.reponse[champ].value
                }
                this.modules.push(justeValeurs)
                this.$nextTick(() => {
                    for (var champ in this.reponseVide){
                        this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                    }
                    
                })
            }  
            this.$emit("answer", {"reponse" :this.modules, "calepinage": this.calepinage})
        },

        //Supprime le modele et mrt a jour calepinage
        deleteItem(item){
            this.modules.splice(this.modules.indexOf(item), 1)
            this.$nextTick(() => {
                for (var i=0; i<this.modules.length; i+=1){
                    this.modules[i].id = i + 1
                }
            })
            let newCalepinage= []
            this.calepinage.forEach(calp => {
                if (calp.typeModule!== item.ref){
                        newCalepinage.push(calp)
                    }
            })
            for (var i = 0; i < newCalepinage.length; i += 1) {
                newCalepinage[i].id = i + 1
            }
            if (this.edition===true){
                this.edition= false
                this.indexEdite = null
                this.$nextTick(() => {
                    for (var champ in this.reponseVide){
                        this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                    }
                    
                })
            }
            this.calepinage=newCalepinage
            this.$emit("answer", {"reponse" :this.modules, "calepinage": this.calepinage})
        },
        openModal(){
            this.modalAjout = true
        },
        save(modele){
            this.pvListe.unshift(modele)
            backend.post_model_module(this.install_id, modele)
            this.modalAjout = false
        }
    },
    watch: {
        reponse: {
            handler() {
                let nouveauRempli = true
                for (var champs in this.reponse){
                    if (this.reponse[champs].required===true && this.reponse[champs].value===""){
                        nouveauRempli = false
                    }
                }
               
                
                this.rempli = nouveauRempli
            },
            deep: true
        },
        modules: {
            //S'il y a au moins un modele, le bouton suivant est activé
            handler(){
                if (this.modules.length > 0){
                    this.$emit('enable')
                }
                else {
                    this.$emit('disable')
                }
            },
            deep: true
        }
    }
}

</script>

<style scoped>


.tableau {
    align-content: center;
    height: 100%;
}

.tableau .theme--light.v-data-table {
    border: 1px solid;
    border-color: rgba(47,47,47,0.5);
    border-radius: 5px;
}

.tableau .theme--light.v-data-table.v-data-table--fixed-header thead th {
    background: unset;
}

.moduleTable{
    height: 100%;
}

.moduleTable >>> .lineEdit {
    background-color: #d9d9d9;
}

.inputCols{
    height: 100%;
}

.formulaire {
    position: relative;
}

.unit{
    padding: 0;
    padding-left: 12px;
    align-content: center;
    font-weight: normal;
}

.complement {
    font-size: 0.7rem;
    font-weight: normal;
    align-content: center;
}

.questions {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    padding: 10px;   
    min-width: 70%;
}

.ajoutModeleBouton {
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px; 
    background-color: #d9d9d9;
    font-size: medium;
}

</style>